import React from 'react';
import { PageBaseComponent } from './page-components';
import EditIcon from './edit-icon';
import { MDCDialog,MDCTextInput,MDCCheckbox } from '../components/mdc-components';


export default class ButtonLinkComponent extends PageBaseComponent {
    constructor(props) {
        super(props)
    }

    componentDidMount() {
        super.componentDidMount();
    }

    onGetContent(data) {
        var content = {
            link: this.state.component.content.link,
            newTarget: this.state.component.content.newTarget,
            label: this.state.component.content.label
        }
        var data = {
            key: this.props.contentKey,
            content: content
        };
        return data;
    }

    onDialogAccept = () => {

    }

    onDialogCancel = () => {
    }

    onEditClick = (event) => {
        this.Dialog.show();
    }

    onChange = (event) => {
        var value = event.target.value;
        this.state.component.content.link = value;
        this.setState(this.state);
    }

    onLabelChange = (event) => {
        var value = event.target.value;
        this.state.component.content.label = value;
        this.setState(this.state);
    }

    onNewTargetChange = (event) => {
        var checked = event.target.checked;
        this.state.component.content.newTarget = checked;
        this.setState(this.state);
    }

    render() {
        let active = this.state.component.active;
        let content = this.state.component.content;
        let editIconPositionCls=this.props.editIconPositionCls ? this.props.editIconPositionCls : 'btn-link-absolute-position';
        
        return (
            <div>
                <div className="relative">
                    <div className={editIconPositionCls}>
                        <EditIcon onClick={this.onEditClick} active={active}>
                            <MDCDialog
                                ref={(ref) => this.Dialog = ref}
                                onDialogAccept={this.onDialogAccept}
                                onDialogCancel={this.onDialogCancel}
                                accept="Save"
                                header="Button Prop"
                            >
                                <div>
                                    <MDCTextInput label="Button Label" onChange={this.onLabelChange} value={content.label} />
                                    <MDCTextInput label="Button Link" onChange={this.onChange} value={content.link} />
                                    <div className="align-left-1">
                                        <MDCCheckbox label="Open in New Tab" onChange={this.onNewTargetChange} checked={content.newTarget} />
                                    </div>    
                                </div>
                            </MDCDialog>
                        </EditIcon>
                    </div>
                    <a className={this.props.buttonCss} href={content.link} target={content.newTarget ? '_blank' : '_self'}>{content.label}</a>
                </div>

            </div>

        );
    }
}